import type { DevicesFilters } from '@/api/routes/devices/types';

export const devicesFilters: DevicesFilters = {
  tags: [],
  content_source: [],
  surface_type: [],
  profile: [],
};
